import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './services/auth/auth.service';
import { LoaderService } from './services/interceptor/loader.service';
import { getUserProfile } from 'src/app/core/session';

@Injectable()
export class AuthGuard  {
    constructor(public auth: AuthService, public router: Router, public _activated: ActivatedRoute) { }

    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.auth.isAuthenticated()) {
            return true;
        } else {
            let url = new URL(window.location.href);
            if (url && url.search && url.search.includes('?sp_id=')) {
                let par = url.search;
                let para = par.replace(/^\D+/g, '')[0];
                this.router.navigate(['/login'], {queryParams: {sp_id: para}});
            } else  if (url && url.search && url.search.includes('&type=dispute')) {
                let par = url.search;
                let para =  new URLSearchParams(par);
                console.log(para)
                this.router.navigate(['/login'], {queryParams: {id: para.get('id'),type: para.get('type')}});
            } else {
                this.auth.redirectToLogin(state.url);
            }
            return false;
        }
    }
}

@Injectable()
export class GSGuard  {
    constructor(public auth: AuthService, public router: Router) { }

    canActivate(): boolean {
        const role = localStorage.getItem('userProfileData') ? (getUserProfile().role_id) : 0;
        const data = localStorage.getItem('userProfileData') ? (getUserProfile()) : {};
        if (localStorage.getItem('userProfileData') == null || localStorage.getItem('userProfileData') == undefined) {
            this.router.navigate(['login'])
            return;
        }
        if ((role != 3 && data && !data.doctor_id) || ((role == 4 || role == 5) && data && data.doctor_id)) {
            return true;
        } else {
            this.router.navigate(['/app/global-settings'], { queryParams: { locId: data.doctor_id } });
            return false;
        }
    }
}
@Injectable()
export class loginAuthGurad  {

    constructor(public auth: AuthService, public router: Router) { }

    canActivate(): any {
        const role = localStorage.getItem('userProfileData') ? (getUserProfile().role_id) : 0;
        if (localStorage.getItem('userProfileData') == null || localStorage.getItem('userProfileData') == undefined) {
            this.router.navigate(['login'])
            return;
        }
        if (role == 12) {
            this.router.navigate(['/app/leads/seminar-lead-list']);
            return false;
        } else if (role == 11) {
            this.router.navigate(['/app/leads/list']);
            return false;
        } else {
            this.router.navigate(['app/finance-customer']);
            return false;
        }
    }
}
@Injectable()
export class FreezGuard  {
    constructor(public auth: AuthService, public router: Router, public routes: ActivatedRoute) { }

    canActivate(routeSnapshot: ActivatedRouteSnapshot): boolean {
        let customRedirect = routeSnapshot['_routerState']['url'];
        let is_freeze=localStorage.getItem("freeze_url");
        let freeze_url_from=localStorage.getItem("freeze_url_from");
        if (!is_freeze) {
            return true;
        } else {
            let url = new URL(window.location.href);
            if (url && url.search && url.search.includes('?type=dispute')) {
                let par = url.search;
                console.log(par)
                let para = par.replace(/^\D+/g, '')[0];
                this.router.navigate(['/login'], {queryParams: {sp_id: para}});
            }

            let requestedPath = String(customRedirect || '').split('?')[0];

            if (requestedPath == '/app/finance' && freeze_url_from == '1') {
                return true
            }
             else if(requestedPath == '/app/process-payment/payment' && freeze_url_from == '2') {
                return true
            }
            else if (requestedPath == '/app/subscriptions/payment' && freeze_url_from == '3') {
                return true
            }

            else if (freeze_url_from == '1') {
                this.router.navigate(['/app/finance']);
            }
            else if (freeze_url_from == '2') {
                this.router.navigate(['/app/process-payment/payment']);
            }
            else if (freeze_url_from == '3') {
                this.router.navigate(['/app/subscriptions/payment']);
            }
            return false;
        }
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocalStorageGuard  {
    constructor(public loaderService: LoaderService) { }

    async canActivate(): Promise<boolean> {
        this.loaderService.show();
        return await this.waitForLocalStorage();
    }

    private waitForLocalStorage(): Promise<boolean> {
        const timeoutMs = 5000;
        return new Promise((resolve) => {
            const startTime = Date.now();
            const interval = setInterval(() => {
                let doctorProfile = localStorage.getItem('doctorProfile');
                let doctorSettings = localStorage.getItem("doctorSettings");
                let getFinanceValues = localStorage.getItem("getFinanceValues");
                let userProfileData = localStorage.getItem("userProfileData");

                const isReady = (doctorProfile && doctorSettings && getFinanceValues && userProfileData)
                    || (userProfileData && JSON.parse(userProfileData)[0].role_id == 1)
                    || (userProfileData && getFinanceValues);

                if (isReady || Date.now() - startTime >= timeoutMs) {
                    clearInterval(interval);
                    this.loaderService.hide();
                    resolve(true);
                }
            }, 100);
        });
    }
}

/**
 * `/app/manage-terminal` only exists for businesses on the terminal flow.
 * The sidebar already hides the entry for everyone else (see
 * `MenuServiceService.getMenu`), so this guard covers the other way in —
 * a typed URL, a bookmark, or a stale deep link — and sends those users
 * back to the dashboard instead of an empty terminal screen.
 */
@Injectable({
    providedIn: 'root'
})
export class TerminalGuard  {
    constructor(public router: Router) { }

    canActivate(): boolean {
        const profile = localStorage.getItem('userProfileData');

        let user: any;
        try {
            user = profile ? JSON.parse(profile)[0] : null;
        } catch {
            user = null;
        }

        if (user?.terminal_flow_enabled) {
            return true;
        }

        this.router.navigate(['/app/dashboard']);
        return false;
    }
}
